import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import APIClient from './APIClient';

import Alert from './Alert';
import Comic from './Comic';

import './Home.css';

const About = () => (
  <Alert title="About Panels">
    This site is a proof-of-concept comic aggregator.<br />
    <br />
    It uses a pluggable comic parsing engine, allowing non-standard comics to be processed successfully. The database defines which parsing class to use, as well as the XPath (or other) queries to apply to the scraped data.
  </Alert>
);

class Home extends React.Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
  };

  state = {
    comics: null,
    error: null,
  };

  componentDidMount() {
    APIClient.shared.getComics()
      .then(comics => this.setState({ comics }))
      .catch(error => this.setState({ error }))
  }

  render() {
    const comics = this.state.comics;

    let alert = null;
    if (comics !== null && comics.length === 0) {
      const message = <span>Visit your <Link to="/profile">profile</Link> to select which comics to display.</span>;
      alert = <Alert
        title="No Comics Selected"
        message={message}
        />
    }

    return (
      <div className="Home">
        {this.state.error && <Alert title="Error" message={this.state.error.message} />}
        {alert}
        {!this.props.isLoggedIn && <About />}
        {comics !== null && comics.map(comic =>
          <Comic key={comic.id} comic={comic} />
        )}
       </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js